import React, { useEffect, useMemo, useState } from "react";
import FlipMove from "react-flip-move";
import getAuctionHub from "../getAuctionHub";
import { formatPriceWs } from "../utils/formatPrice";
import styles from "./AuctionHall.module.scss";
import AuctionHallItem from "./AuctionHallItem";
import logger from "../utils/logger";
import config from "../utils/config";
import auctionApiClient from "../auctions-list-page/AuctionApiClient";
const UnbiddablePeriodBeforePodium = 3;
const SoldItemsCount = 5;
const UpcomingItemsCount = 10;
const AnimationDuration = 350;
export function AuctionHall(props) {
    const [data, setData] = useState({
        currentLotNumber: 0,
        items: [],
    });
    const podiumItem = useMemo(() => {
        return data.items.find((i) => i.number == data.currentLotNumber);
    }, [data]);
    const podiumItemIndex = useMemo(() => data.items.indexOf(podiumItem), [data, podiumItem]);
    const loadData = async (currentLotNumber) => {
        const searchResult = await auctionApiClient.searchItems({
            // We have two sections: Sold and Active items + podium
            limit: SoldItemsCount + 1 + UpcomingItemsCount,
            // Inclusive lower bound of lot number
            minLotNumber: currentLotNumber - SoldItemsCount,
            // Inclusive upper bound of lot number
            maxLotNumber: currentLotNumber + UpcomingItemsCount,
            auctionId: props.auctionId,
            sort: "ObjectNumber",
            type: "AllItems",
        });
        setData({
            currentLotNumber,
            items: searchResult.items,
        });
    };
    useEffect(() => {
        logger.pageView();
        getAuctionHub().then((hub) => hub === null || hub === void 0 ? void 0 : hub.watchPodium(async (podiumChanged) => {
            await loadData(podiumChanged.currentLotNumber);
            // make sure the animation is done before a new animation is started
            await new Promise((res) => setTimeout(res, AnimationDuration * 2));
        }));
        void loadData(props.currentLotNumber);
    }, []);
    return (React.createElement("div", { className: styles.content },
        React.createElement("h1", null, props.strings.auctionHall),
        React.createElement("h2", { className: styles.onPodium },
            props.strings.onPodium,
            ":"),
        React.createElement("div", { className: styles.tableHeader },
            React.createElement("span", null, props.strings.objectNr),
            React.createElement("span", null, props.strings.status),
            React.createElement("span", null, props.strings.price)),
        podiumItem && React.createElement("div", { className: styles.podium },
            React.createElement("img", { src: `${config.auctionItemsImagesRootUrl}/img/${podiumItem.id}/${podiumItem.mainImageFileId}`, alt: `Lot ${podiumItem.number}` }),
            React.createElement("h2", null,
                props.strings.objectNr,
                " ",
                podiumItem.number),
            React.createElement("p", null,
                props.strings.objectNr,
                " ",
                podiumItem.number),
            podiumItem.condition && (React.createElement("p", null,
                props.strings.quality,
                ": ",
                podiumItem.condition)),
            React.createElement("hr", null),
            React.createElement("p", null, podiumItem.description),
            React.createElement("p", { className: styles.lotPrice },
                props.strings.price,
                " ",
                formatPriceWs(podiumItem.currentBidPrice)),
            React.createElement("p", null,
                props.strings.bidCount,
                ": ",
                podiumItem.bidsCount)),
        React.createElement("h2", { className: styles.objects },
            props.strings.objects,
            ":"),
        React.createElement(FlipMove, { className: styles.items, leaveAnimation: "accordionVertical", duration: AnimationDuration }, data.items.map((item, index) => (React.createElement(AuctionHallItem, { key: item.id, item: item, strings: props.strings, auctionUrl: props.auctionUrl, imageBaseUrl: config.auctionItemsImagesRootUrl, isCurrent: podiumItem.id == item.id, canBid: index >
                podiumItemIndex + UnbiddablePeriodBeforePodium }))))));
}
